module.exports = __webpack_public_path__ + "img/shop_white.d0a355b9.svg";